export enum FbaAssessmentDetailsHelp {
  CategoryBehavior = 'Category of Behavior',
  OperationalDef = 'Operational Definition',
  DimensionBehavior = 'Dimension of Behavior Measured',
}

export enum FbaSummaryHelp {
  HypothesisStatement = 'Hypothesis Statement',
}
